import zIndex from "@mui/material/styles/zIndex"

export const Content_Type = [
    { id: 1, label: "Articles" },
]

export const Status=[
    { id: 1, label: "Published" },
    { id: 2, label: "Unpublished" }
]

export const Languages = [
    { id: 44, label: "English" },
    { id: 66, label: "Hindi" },
]

// need to change id as requirement
export const Content_Subscription_Type = [
    { id: 7, label: "Free Seo" },
    { id: 0, label: "Premium Seo" }
]

export const Ptatform_Type = [
    { id: 1, label: "App" },
    { id: 2, label: "Web/Mobile" }
]

export const Entity_Type = [
    { id: 1, label: "branch" },
    { id: 2, label: "college" },
    { id: 3, label: "degree" },
    { id: 4, label: "exam" },
    { id: 5, label: "country" },
    { id: 6, label: "career" },
    { id: 7, label: "scholarship" },
    { id: 8, label: "jobs" },
    { id: 9, label: "certificate" },
    { id: 10, label: "domain" },
    { id: 11, label: "comapny" },
    { id: 12, label: "syllabus" },

]

export const Author = [
    { id: 1, label: "Author 1" },
    { id: 2, label: "Author 2" },
    { id: 3, label: "Author 3" },
]

export const Title = [
    { id: 1, title: "Title 1" },
    { id: 2, title: "Title 2" },
    { id: 3, title: "Title 3" },
]

export const Featured = [
    { id: 0, label: "Unmarked" },
    { id: 1, label: "Marked" }
]

export const ListData=[
    {
        id: 1,
        title: "Title 1",
        author: "Author 1", 
        level: "Level 1", 
        article_main_category: "Category 1", 
        platform: "App", 
        created: "April 28 2020 12:27 p.m.", 
        updated: "April 28 2020 12:27 p.m.", 
        language: "English", 
        domain: "Law", 
        status: "Published"
    }

]

export const formatDateTime =(dateTimeString)=> {
    const date = new Date(dateTimeString);

    // Get day suffix
    const day = date.getDate();
    const daySuffix = getDaySuffix(day);

    // Get month name
    const month = date.toLocaleString('default', { month: 'short' });

    // Get time in 12-hour format
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'p.m' : 'a.m';
    hours %= 12;
    hours = hours || 12; // Handle midnight

    return `${day}${daySuffix} ${month} ${date.getFullYear()} at ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
}

export const getDaySuffix=(day)=> {
    switch (day) {
        case 1:
        case 21:
        case 31:
            return 'st';
        case 2:
        case 22:
            return 'nd';
        case 3:
        case 23:
            return 'rd';
        default:
            return 'th';
    }
}

export const Custom_Styles = {
    menu: (base) => ({
        ...base,
        maxHeight: '190px', // adjust this value as needed
        overflow:"auto",
        zIndex:"99"
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '190px', // adjust this value as needed
        padding: 0,
        overflow:"auto"
    })
};
export const List_Data={
    "lastPage": 150,
    "itemsOnPage": "30",
    "current": 1,
    "next": "http://backend-service.careers360.org/api/1/cms/article-list?page=2&page_size=20&type=articles",
    "previous": null,
    "totalRows": 2,
    "results": [
        {
            "id": 32,
            "story_name": "Work After Study in USA",
            "entity_types": "branch",
            "keywords": "articles/work-after-study-in-usa",
            "language": 44,
            "domain": "engineering",
            "status": "published",
            "created": "2024-07-09T06:31:28Z",
            "updated": "2025-03-06T11:31:02Z"
        },
        {
            "id": 2067,
            "story_name": "Post Study Work Visa Germany - Everything You Need to Know",
            "entity_types": "college",
            "keywords": "articles/post-study-work-visa-germany",
            "language": 44,
            "domain": "law",
            "status": "published",
            "created": "2024-07-10T16:08:17Z",
            "updated": "2025-03-05T07:19:42Z"
        },
    ]
}